import styled from 'styled-components';
import { FlexContainer } from '@taxdown/piccolo-web';

export const Container = styled(FlexContainer)`
  width: 768px;
  padding: 0 ${({ theme: { reference } }) => `${reference.dimension_16} ${reference.dimension_16}`};
  .input-transform input {
    text-transform: uppercase;
  }
  .input-transform input::placeholder {
    text-transform: none;
  }
  @media (max-width: ${({ theme: { reference } }) => reference.breakpoints.MOBILE_WIDTH}) {
    width: 100%;
    padding: ${({ theme: { reference } }) => reference.dimension_16};
  }
`;

export const Link = styled.a`
  color: ${({ theme: { colors } }) => colors.green_500};
  text-decoration: none;
`;

export const ContentContainer = styled(FlexContainer)`
  gap: ${({ theme: { reference } }) => reference.dimension_40};
  form {
    max-width: 100%;
    align-items: center;
  }
  @media (max-width: ${({ theme: { reference } }) => reference.breakpoints.MOBILE_WIDTH}) {
    gap: 0;
  }
`;
export const ButtonContainer = styled(FlexContainer)`
  padding: ${({ theme: { reference } }) => reference.dimension_16};
  height: 70px;
  width: 100%;
  position: sticky;
  bottom: 0;
  left: 0;
  background: ${({ theme: { colors } }) => colors.white};
  padding: ${({ theme: { spacing } }) => spacing.spacing_16};
  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1);
  z-index: 10;
`;
